<template>
  <div>
    <v-row>
      <v-col cols="12">
        <header>CH-A</header>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          label="1次管理値"
          :value="threshold.primary"
          @input="$emit('update', { primary: $event })"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <header>CH-A</header>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          label="2次管理値"
          :value="threshold.secondary"
          @input="$emit('update', { secondary: $event })"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <header>CH-A</header>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          label="3次管理値"
          :value="threshold.tertiary"
          @input="$emit('update', { tertiary: $event })"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "AxialLoadThresholdForm",
  props: ["threshold"],
};
</script>
